import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import TierContent from './TierContent';
import TierContentV2 from '../TierContent__posts_tiers';

export default withFeatureBranch({ posts_tiers: TierContentV2 })(TierContent);
